import { Injector } from "@angular/core";
import { Validators } from "@angular/forms";

import { transactionDataType } from "@bitwarden/web-vault/app/models/types/transactionData.types";
import { TransactionDirection } from "@bitwarden/web-vault/app/models/enum/transactionDirection";
import { InputTypes } from "../../../../models/enum/inputTypes.enum";
import { TransactionStatusEnum } from "../../../../models/enum/transactionType";
import { FormInterface } from "../../../../models/interfaces/form.interface";
import { GlossInputOptions, isOfType } from "../../../../models/types/general-types";
import { AccountView } from "../../../../models/view/account/account.view";
import { BaseForm } from "../../../../shared/form/BaseForm";
import { HelperNumericInput } from "../../../../shared/utils/helper-numeric-input";
import {
  AllowedCurrencies,
  CurrencyType,
} from "@bitwarden/web-vault/app/models/types/location-currency.types";
import { accountManualType } from "@bitwarden/web-vault/app/models/types/account.types";

export class TransactionForm extends BaseForm implements FormInterface {
  currency: CurrencyType;
  transactionType: "IN" | "OUT" = "IN";
  isEditTransaction = false;
  currentAccount: AccountView = null;

  selectedAccount: AccountView;

  constructor(injector: Injector, selectedAccount: AccountView) {
    super(injector);
    this.selectedAccount = selectedAccount;

    this.title = this.i18nService.t("enterAccountData");
    this.initialize();
  }

  initialize() {
    if (isOfType<CurrencyType>(this.selectedAccount?.currency, AllowedCurrencies)) {
      this.currency = this.selectedAccount.currency;
    } else {
      this.currency = this.getCurrencyFromLocation();
    }

    this.formGroup = this.formBuilder.group({
      symbol: [null],
      currency: [this.currency, Validators.required],
      categoryId: [null],
      quantity: [null, [HelperNumericInput.isNumberValidator]],
      amount: [null, [HelperNumericInput.isNumberValidator, Validators.required]],
      asOfDate: [null],
      date: [this.dateFormat.getDateStringFromStamp(new Date().getTime()), Validators.required],
      time: [null],
      description: [null, Validators.required],
      transactionStatus: TransactionStatusEnum.transaction,
      type: [this.transactionType, Validators.required],
    });
  }

  getPriceInputLabel(): string {
    return this.selectedAccount?.type === accountManualType.bank ||
      this.selectedAccount?.type === accountManualType.credit
      ? this.i18nService.t("amount")
      : this.i18nService.t("unitPrice");
  }

  selectDirection(selectedDirection: TransactionDirection) {
    this.formGroup.controls.type.setValue(selectedDirection);
  }

  selectCategory(selectedCategoryId: string) {
    this.formGroup.controls.categoryId.setValue(selectedCategoryId);
  }

  selectQuantity(quantity: number) {
    this.formGroup.controls.quantity.setValue(quantity);
  }

  // the submit logic has been passed to the component who instantiate this class
  submit(): transactionDataType | "touched" {
    let result: transactionDataType = null;
    result = {
      account: this.selectedAccount,
      formData: this.formGroup.value,
    };
    if (this.formGroup.valid) {
      if (this.currentAccount) {
        this.selectedAccount = this.currentAccount;
        this.currentAccount = null;
      }
      this.isEditTransaction = false;
      return result;
    } else if (
      this.formGroup.value.description ||
      this.formGroup.value.amount ||
      this.formGroup.value.date
    ) {
      return "touched";
    }
  }
}
